import { ChildrenProp } from "../../types/common";
import { UserAgentContext, UserDevice } from "./UserAgentContext";
import { useMemo } from "react";

const TABLET_MIN_WIDTH = 768;
const DESKTOP_MIN_WIDTH = 1380;

export function UserAgentProvider({ children }: ChildrenProp) {
  const device = useMemo((): UserDevice => {
    const innerWidth = window.innerWidth;
    switch (true) {
      case innerWidth >= DESKTOP_MIN_WIDTH:
        return UserDevice.DESKTOP;
      case innerWidth >= TABLET_MIN_WIDTH:
        return UserDevice.TABLET;
      default:
        return UserDevice.MOBILE;
    }
  }, []);

  const isDesktop = useMemo(() => device === UserDevice.DESKTOP, [device]);
  const isTablet = useMemo(() => device === UserDevice.TABLET, [device]);
  const isMobile = useMemo(() => device === UserDevice.MOBILE, [device]);

  return (
    <UserAgentContext.Provider value={{ isDesktop, isTablet, isMobile, device }}>{children}</UserAgentContext.Provider>
  );
}
